var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "div",
        {
          staticClass: "mt20",
          staticStyle: { "margin-bottom": "20px", color: "red" },
        },
        [_vm._v("\n      注意：售后申请退款时，不退运费，只退商品金额\n      ")]
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                border: true,
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
                "row-key": function (row) {
                  return row.no
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "售后申请编号",
                  prop: "no",
                  "min-width": "210",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单号", "min-width": "210" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          staticStyle: { display: "block" },
                          domProps: { textContent: _vm._s(scope.row.orderNo) },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "applyType",
                  label: "售后类型",
                  "min-width": "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.applyType == "return"
                          ? _c("span", { staticStyle: { display: "block" } }, [
                              _vm._v("退货"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "退款状态",
                  prop: "refundStatus",
                  "min-width": "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.refundStatus == 0
                          ? _c("span", { staticStyle: { display: "block" } }, [
                              _vm._v("未退款"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.refundStatus == 1
                          ? _c("span", { staticStyle: { display: "block" } }, [
                              _vm._v("申请中"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.refundStatus == 3
                          ? _c("span", { staticStyle: { display: "block" } }, [
                              _vm._v("退款中"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.refundStatus == 2
                          ? _c("span", { staticStyle: { display: "block" } }, [
                              _vm._v("已退款"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "退款金额",
                  prop: "refundPrice",
                  "min-width": "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品信息", "min-width": "400" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.productList && scope.row.productList.length
                          ? _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              _vm._l(scope.row.productList, function (val, i) {
                                return _c(
                                  "div",
                                  {
                                    key: i,
                                    staticClass: "tabBox acea-row row-middle",
                                    staticStyle: { "flex-wrap": "inherit" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "demo-image__preview mr10",
                                      },
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: val.picUrl,
                                            "preview-src-list": [val.picUrl],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text_overflow" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "tabBox_tit mr10" },
                                          [_vm._v(_vm._s(val.spuName))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "tabBox_tit mr10" },
                                          [_vm._v(_vm._s(val.sku))]
                                        ),
                                        _vm._v(" "),
                                        _vm.$selfUtil.isUsePriceBiz(
                                          scope.row.bizType
                                        )
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "tabBox_tit mr10",
                                              },
                                              [
                                                _vm._v(
                                                  "￥" +
                                                    _vm._s(val.price) +
                                                    "x " +
                                                    _vm._s(val.count)
                                                ),
                                              ]
                                            )
                                          : scope.row.bizType == 2
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "tabBox_tit mr10",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(val.pointsPrice) +
                                                    "积分 x " +
                                                    _vm._s(val.count)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "applyReason",
                  label: "申请原因",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "applyDescription",
                  label: "描述",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "凭证", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.applyPicUrls != "" &&
                        null != scope.row.applyPicUrls
                          ? _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              _vm._l(
                                scope.row.applyPicUrls.split(","),
                                function (val, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: i,
                                      staticClass: "tabBox acea-row row-middle",
                                      staticStyle: { "flex-wrap": "inherit" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "demo-image__preview mr10",
                                        },
                                        [
                                          _c("el-image", {
                                            attrs: {
                                              src: val,
                                              "preview-src-list": [val],
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          scope.row.status == 1
                            ? _c("span", [_vm._v("提交申请")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 2
                            ? _c("span", [_vm._v("商家同意退款")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 3
                            ? _c("span", [_vm._v("待卖家收货")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 4
                            ? _c("span", [_vm._v("卖家已收货，待退款")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 5
                            ? _c("span", [_vm._v("售后已完成")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 6
                            ? _c("span", [_vm._v("买家取消售后")])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status == 7
                            ? _c("span", [_vm._v("卖家拒绝退款")])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "申请时间",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "150",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            scope.row.status < 5
                              ? _c(
                                  "span",
                                  { staticClass: "el-dropdown-link" },
                                  [
                                    _vm._v("\n                处理"),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-down el-icon--right",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                scope.row.status === 1 &&
                                _vm.checkPermi(["admin:order:refund:refuse"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.onOrderRefuse(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("拒绝")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.status === 1 &&
                                _vm.checkPermi(["admin:order:refund"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.onOrderRefund(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("同意")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.status === 3 &&
                                _vm.checkPermi(["admin:order:refund"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.onReceive(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("确认收货")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.status === 4 &&
                                _vm.checkPermi(["admin:order:refund"]) &&
                                scope.row.refundStatus == 1
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.doOrderRefund(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("确认退款")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.RefuseVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "拒绝退款原因",
                visible: _vm.RefuseVisible,
                width: "500px",
                "before-close": _vm.RefusehandleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.RefuseVisible = $event
                },
              },
            },
            [
              _c("zb-parser", {
                attrs: {
                  "form-id": 146,
                  "is-create": 1,
                  "edit-data": _vm.RefuseData,
                },
                on: {
                  submit: _vm.RefusehandlerSubmit,
                  resetForm: _vm.resetFormRefusehand,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款处理",
            visible: _vm.refundVisible,
            width: "500px",
            "before-close": _vm.refundhandleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.refundVisible = $event
            },
          },
        },
        [
          _vm.refundVisible
            ? _c("zb-parser", {
                attrs: {
                  "form-id": 145,
                  "is-create": 1,
                  "edit-data": _vm.refundData,
                },
                on: {
                  submit: _vm.refundhandlerSubmit,
                  resetForm: _vm.resetFormRefundhandler,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }